import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import YouTube from "react-youtube";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Video = () => {
  const videos = [
    { id: "ZMByWenSRdI", title: "", likes: "", views: "" },
    { id: "frmwfMTRg-Q", title: "", likes: "", views: "" },
    { id: "TWxheSgWDpI", title: "", likes: "", views: "" },
    { id: "Tuw8hxrFBH8", title: "", likes: "", views: "" },
  ];

  // Slick carousel settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // lg
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640, // sm
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // YouTube player options
  const youtubeOpts = {
    height: "200",
    width: "100%",
    playerVars: {
      autoplay: 0,
    },
  };

  return (
    <div>
      <section className="my-20 sm:px-20 px-5">
        <div className="flex items-center justify-between w-full max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900">Short Videos</h2>
          <Link
            to="/videos"
            className="text-lg text-blue-600 hover:text-blue-800 transition-colors duration-300"
          >
            See All
          </Link>
        </div>
        <div className="w-full max-w-5xl mx-auto">
          <Slider {...settings}>
            {videos.map((video) => (
              <div key={video.id} className="px-2">
                <div className="bg-white rounded-lg shadow-md overflow-hidden">
                  <YouTube
                    videoId={video.id}
                    opts={youtubeOpts}
                    className="w-full aspect-video"
                  />
                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">
                      {video.title}
                    </h3>
                    <div className="flex justify-between text-sm text-gray-600">
                      <span>{video.views} </span>
                      <span>{video.likes} </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </div>
  );
};

export default Video;